import { initializeApp } from 'firebase/app';
import 'firebase/auth';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const credentials = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

// Config for qmerit firestore
const qmeritFirebaseConfig = {
  apiKey: process.env.QMERIT_FIREBASE_API_KEY,
  authDomain: process.env.QMERIT_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.QMERIT_FIREBASE_PROJECT_ID,
  storageBucket: process.env.QMERIT_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.QMERIT_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.QMERIT_FIREBASE_APP_ID,
  measurementId: process.env.QMERIT_FIREBASE_MEASUREMENT_ID,
};

const instance = initializeApp(credentials);

export const qmeritInstance = initializeApp(qmeritFirebaseConfig, 'qmerit');

export const qmeritFirestore = getFirestore(qmeritInstance);

export const auth = getAuth(instance);

export default instance;
